import { AccountButton } from "../../../common/components/AccountButton";
import { useGetEmployeeMeQuery } from "../../../common/api/employee";
import { getInitials } from "../../../common/utils/getInitials";
import absLogo from "../../../common/images/AbsLogo.svg";
import { Button } from "@hatch-digital-nl/abs-storybook/legacy";
import { JSX, useContext } from "react";
import { getUserFullName } from "../../../common/utils/getUserFullName";
import { redirectToPortalWebLogout } from "../../../common/utils/portalWebLogout";
import { AuthContext, IAuthContext } from "react-oauth2-code-pkce";

export const EmployeeInactiveHeader = (): JSX.Element | null => {
    const { idToken } = useContext<IAuthContext>(AuthContext);
    const { data: employeeMeData, isLoading: employeeMeDataIsLoading } =
        useGetEmployeeMeQuery({});
    if (employeeMeDataIsLoading || !employeeMeData) {
        return null;
    }

    return (
        <div className={"p-employee-inactive__header"}>
            <AccountButton
                initials={getInitials(
                    getUserFullName(employeeMeData.user) ?? undefined,
                )}
                fullName={getUserFullName(employeeMeData.user) ?? undefined}
                company={employeeMeData.establishment.name}
            />
            <div className={"p-employee-inactive__header__logo"}>
                <img src={absLogo} alt={"Logo"} />
            </div>
            <Button
                variant={"quaternary"}
                onClick={() => redirectToPortalWebLogout(idToken)}
            >
                Uitloggen
            </Button>
        </div>
    );
};
